import {keepPreviousData, useQuery} from "@tanstack/react-query";

import {listSupplierOffersQueryOptions} from "./list-supplier-offers.query-options";
import type {ListSupplierOffersSearchInput} from "./list-supplier-offers.schema";

export function useListSupplierOffers(input: ListSupplierOffersSearchInput) {
  return useQuery({...listSupplierOffersQueryOptions(input), placeholderData: keepPreviousData});
}
